module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-300.07d277dd.woff2";